import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { isEmpty } from 'lodash';

import { IndustryCatalogType } from '@core/shared/domain';
import {
  DEFAULT_PAGINATION,
  PlatformCatalogFilter,
  PlatformcatalogSearchQueryField,
} from '@mp/content-manager/plattformkataloge/data-access';
import { QueryParamsFilterConverterInterface, getEnumValue } from '@mp/shared/data-access';

const SEARCH_FIELD_PARAM_KEY = 'field';
const SEARCH_QUERY_PARAM_KEY = 'searchTerm';
const ONLY_UPDATED_QUERY_PARAM_KEY = 'onlyUpdated';
const CATALOG_TYPE_QUERY_PARAM_KEY = 'catalogType';
const DATASOURCES_QUERY_PARAM_KEY = 'dataSources';

const INDUSTRY_PAGE_QUERY_PARAM_KEY = 'page';
const INDUSTRY_PAGE_SIZE_QUERY_PARAM_KEY = 'pageSize';

@Injectable()
export class PlatformkatalogeQueryParamsFilterConverterFacade
  implements QueryParamsFilterConverterInterface<PlatformCatalogFilter>
{
  convertToQueryParams(filter: Partial<PlatformCatalogFilter>): Params {
    return {
      [SEARCH_FIELD_PARAM_KEY]: filter.field !== null ? filter.field : undefined,
      [SEARCH_QUERY_PARAM_KEY]: filter.searchTerm !== '' ? filter.searchTerm : undefined,

      [ONLY_UPDATED_QUERY_PARAM_KEY]: filter.updatedOnly ? 1 : undefined,
      [CATALOG_TYPE_QUERY_PARAM_KEY]: !isEmpty(filter.catalogType) ? filter.catalogType?.join(',') : undefined,
      [DATASOURCES_QUERY_PARAM_KEY]: !isEmpty(filter.dataSources) ? filter.dataSources?.join(',') : undefined,

      [INDUSTRY_PAGE_QUERY_PARAM_KEY]: filter.page === DEFAULT_PAGINATION.page ? undefined : filter.page,
      [INDUSTRY_PAGE_SIZE_QUERY_PARAM_KEY]:
        filter.pageSize === DEFAULT_PAGINATION.pageSize ? undefined : filter.pageSize,
    };
  }

  convertFromQueryParams(queryParams: Params): PlatformCatalogFilter {
    return {
      ...DEFAULT_PAGINATION,
      field: queryParams[SEARCH_FIELD_PARAM_KEY] || PlatformcatalogSearchQueryField.All,
      searchTerm: queryParams[SEARCH_QUERY_PARAM_KEY] || '',
      updatedOnly: queryParams[ONLY_UPDATED_QUERY_PARAM_KEY] === '1',
      catalogType: queryParams[CATALOG_TYPE_QUERY_PARAM_KEY]
        ? queryParams[CATALOG_TYPE_QUERY_PARAM_KEY].split(',')
            .map((val: string) => getEnumValue(IndustryCatalogType, val))
            .filter((val: IndustryCatalogType | undefined) => !!val)
        : undefined,

      dataSources: queryParams[DATASOURCES_QUERY_PARAM_KEY]
        ? queryParams[DATASOURCES_QUERY_PARAM_KEY].split(',')
            .map((val: string) => val)
            .filter((val: string | undefined) => !!val)
        : undefined,

      page: parseInt(queryParams[INDUSTRY_PAGE_QUERY_PARAM_KEY], 10) || DEFAULT_PAGINATION.page,
      pageSize: parseInt(queryParams[INDUSTRY_PAGE_SIZE_QUERY_PARAM_KEY], 10) || DEFAULT_PAGINATION.pageSize,
    };
  }
}
